<script lang="ts">
	import { Asset } from '@atoms';
	import { Carousel } from '@core/builders/carousel/Carousel.svelte';
	import { SnapAlign } from '@core/builders/carousel/modifiers/Snap';
	import { type ImageData } from '@queries/datoCMS/DatoCMSQueries';

	let { assets }: { assets: ImageData[] } = $props();

	const carousel = Carousel.from(assets, {
		drag: true,
		snap: { align: SnapAlign.START },
		scroll: {
			mode: 'interval',
			auto: -2
		}
	});

	$effect(() => {
		if (assets.length <= 1) carousel.stop();
	});
	// delete this on comment when you see it.
</script>

<div class="container" use:carousel.useContainer {...carousel.attr.container}>
	{#each carousel.items as asset}
		<div class="item" use:asset.useItem {...asset.attr}>
			<Asset data={asset.data}></Asset>
		</div>
	{/each}
</div>

<style lang="scss">
	.container {
		width: 100%;
		height: 100%;
		overflow: hidden;
	}
	.item {
		height: 100%;
		width: 100%;
	}
</style>
